import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { calendarEntryPoint } from '@atlassian/jira-spa-apps-software-calendar/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';

export const softwareCalendarRouteEntry = createPageEntryPoint({
	main: calendarEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	// TODO: Adopt sidebar entrypoints when calender route enables SSR
	// leftSidebar: {
	// 	sidebar: nav4SidebarContentCoreEntryPoint,
	// 	entryPoints: {
	// 		projects: {
	// 			entryPoint: nav4ProjectsContentEntryPoint,
	// 		},
	// 		boards: {
	// 			entryPoint: nav4JSWProjectEntryPoint,
	// 		},
	// 	},
	// 	isProjectsExpanded: true,
	// },
});
